import {
  Button,
  Card,
  CardContent,
  Typography,
  makeStyles,
} from "@material-ui/core";
import CardActions from "@material-ui/core/CardActions";
import notificationdatalogo from "../../component/image/notification/notificationdatalogo.png";

import React, { useEffect, useState } from "react";
import { getJobNotification } from "../../service/services";
import ManImg from "./man.jpg";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiCardContent-root": {
      padding: "0",
    },
    margin: "1rem 0.5rem",
  },
  head1: {
    align: "left",
    fontWeight: "bold",
    color: "#223852",
    fontFamily: "'Playfair Display', serif !important",
    fontSize: "1.5625rem",
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: "2.5rem",
  },
  head2: {
    fontWeight: "normal",
  },
  content: {
    display: "flex",
  },
  cardnoti: {
    minWidth: 275,
    height: "235px",
    padding: "0.5rem",
    "& .MuiCardActions-root": {
      justifyContent: "space-between",
      // [theme.breakpoints.down("xs")]: {
      //   flexDirection: "column",
      // },
    },
    "& .MuiCardActions-spacing > :not(:first-child)": {
      marginLeft: "2rem",
      [theme.breakpoints.down("xs")]: {
        marginLeft: "0rem",
        marginTop: "1rem",
      },
    },
  },
  notihead3: {
    // textDecorationLine: "underline",
    // textDecorationColor: "orange",
    fontSize: "18px",
    fontWeight: "bold",
    display: "-webkit-box",
    WebkitLineClamp: 1,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    "&:hover": {
      color: "#FFC736 !important",
      background:"transparent"
    },
  },
  notihead4: {
    fontSize: "15px",
    fontWeight: "bold",
  },

  thumbnailscontainer: {
    background: "#FFFFFF",
    padding: "0.5rem 0.5rem",
    borderRadius: "0.375rem",
    background: "#FFFFFF",
    display: "flex",
    alignItems: "center",
    boxShadow: "0px 6px 20px 0px rgba(0, 0, 0, 0.10)",
    "& img": {
      marginRight: "0.5rem",
    },
    [theme.breakpoints.down("xs")]: {
      width: "70%",
    },
  },
  clampText: {
    display: "-webkit-box",
    marginLeft: "0.5rem",
    WebkitLineClamp: 5,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    [theme.breakpoints.down("xs")]: {
      WebkitLineClamp: 4,
    },
    "& h4": {
      margin: "0",
      fontSize: "1rem",
      fontFamily: "Jost",
      fontWeight: "400",
      color: "#676767 !important",
      textTransform: "capitalize",
    },
    "& p": {
      margin: "0",
      fontSize: "1rem",
      fontFamily: "Jost",
      fontWeight: "400",
      color: "#676767 !important",
      textTransform: "capitalize",
    },
    "& ul": {
      display: "none",
    },
    "& span": {
      margin: "0",
      fontSize: "1rem",
      fontFamily: "Jost",
      fontWeight: "400",
      color: "#676767 !important",
      textTransform: "capitalize",
    },
  },
  cover: {
    width: "110px !important",
    height: "110px",
    background: "#FFE8B5",
    borderRadius: "8px",
    padding: "0.3rem",
  },
  readmorebtn: {
    color: "rgba(21, 79, 229, 1)",
    fontSize: "0.625rem",
    fontWeight: "600",
    textTransform: "uppercase",
    textDecoration: "none",
    "&:hover": {
      background:"transparent"
    },
  },
}));

const DateComponent = ({ Notification1 }) => {
  const classes = useStyles();
  const navigate = useNavigate();

  const formatDateString = (dateString) => {
    // Check if the date string is not empty and is a valid date
    if (!dateString || isNaN(new Date(dateString).getTime())) {
      return "Invalid Date";
    }

    const date = new Date(dateString);
    const day = date.getDate();
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };

  return (
    <>
      <div className={classes.root}>
        <Card className={classes.cardnoti}>
          <CardContent>
            <Button
              // className={classes.readmorebtn}
              className={classes.notihead3}
              disableRipple
              onClick={() => {
                navigate(`/currentaffairs/${Notification1?.id}`);
              }}
            >
              {Notification1?.heading}
            </Button>
          </CardContent>
          <CardContent className={classes.content}>
            {Notification1?.thumbnail_image || Notification1?.main_image ? (
              <div className={classes.cover}>
                <img
                  src={
                    Notification1?.thumbnail_image || Notification1?.main_image
                  }
                  alt="img"
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                  }}
                />
              </div>
            ) : null}

            <div className={classes.details}>
              <CardContent>
                <Typography
                  component="div"
                  variant="h5"
                  className={classes.clampText}
                  dangerouslySetInnerHTML={{
                    __html: Notification1?.discription,
                  }}
                />
              </CardContent>
            </div>
          </CardContent>
          <CardActions>
            <div className={classes.thumbnailscontainer}>
              <img src={notificationdatalogo} alt="logo" />
              {formatDateString(Notification1?.created_at)} Created
            </div>
            <Button
              className={classes.readmorebtn}
              disableRipple
              onClick={() => {
                navigate(`/currentaffairs/${Notification1?.id}`);
              }}
            >
              Read More
            </Button>
          </CardActions>
        </Card>
      </div>
    </>
  );
};

export default DateComponent;
